import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import HeadingStyles from '@stories/Components/Global/Typography/Heading.styles';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import styled, { css } from 'styled-components';
const BackgroundContainer = styled.div `
  position: relative;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0px;
    width: 100%;
    height: min(100%, 500px);
    clip-path: polygon(100% 0, 0% 100%, 100% 100%);
    background-color: ${brand.grey.grey96};
    z-index: -1;
  }
`;
const Container = styled.div `
  grid-column: span 12;
  padding: 50px 0px;
  z-index: 1;

  @media ${from(Device.TabletLarge)} {
    grid-column: 2 / span 10;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 3 / span 8;
  }

  @media ${from(Device.DesktopLarge)} {
    grid-column: 4 / span 6;
  }

  ${HeadingStyles.Heading} {
    text-align: center;
    color: ${brand.primary.alt};
  }
`;
const FAQs = styled.div `
  display: flex;
  flex-direction: column;
`;
const FAQQuestion = styled.h3 `
  ${fonts.DaxPro.Regular};
  font-size: 24px;
  color: ${brand.grey.grey20};
  padding-right: 60px;
  position: relative;
  margin-bottom: 12px;
  cursor: pointer;

  > svg {
    position: absolute;
    top: 0;
    right: 0;
    width: 29px;
    height: 14px;
    stroke: ${brand.black};
    transform: rotate(180deg);
  }
`;
const FAQAnswer = styled.div `
  ${ParagraphStyles.RegularStyles};
  display: none;
  margin-top: 12px;
  margin-bottom: 0px;

  a {
    color: ${brand.primary.alt};
  }
`;
const FAQ = styled.div `
  padding-bottom: 22px;
  border-bottom: 2px solid ${brand.primary.base};
  margin-bottom: 28px;

  ${({ isActive }) => isActive
    ? css `
          ${FAQAnswer} {
            display: block;
          }

          ${FAQQuestion} > svg {
            transform: rotate(0deg);
          }
        `
    : css `
          ${FAQAnswer} {
            display: none;
          }
        `}
`;
export const FAQListStyles = {
    BackgroundContainer,
    Container,
    FAQs,
    FAQQuestion,
    FAQAnswer,
    FAQ,
};
